import asCanvasElement from './CanvasElement';
import type { CanvasElementProps } from './types';

export type { CanvasElementProps };
export default asCanvasElement;
